import { createAsyncThunk } from '@reduxjs/toolkit';
import { ENROLL_ABHA_VIA_AADHAAR } from '@custom/constant';
import { abhaEnrollViaAadhaarType } from '@custom/Utils/constants/interfaces';

const EnrollABHAviaAadhaar = createAsyncThunk(
    'abha/verify',
    async (payload: abhaEnrollViaAadhaarType, { rejectWithValue }) => {
        try {
            const token = sessionStorage.getItem('token') || localStorage.getItem('token');
            const response = await fetch(ENROLL_ABHA_VIA_AADHAAR, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                throw new Error('Failed to verify otp');
            }

            return await response.json();
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export default EnrollABHAviaAadhaar